import { ArrowRight } from "@phosphor-icons/react"
import { LinkButton } from "@tokenterminal/core/ui/button/LinkButton"
import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import { Card } from "@tokenterminal/core/ui/layout/card/Card"
import Image from "next/image"
import { twMerge } from "tailwind-merge"
import { groupedTestimonials } from "../../constants/content"
import Container from "../common/Container"
import MarketingHeading from "../common/MarketingHeading"

const TestimonialCard = ({ testimonial }: { testimonial: any }) => (
  <Card
    className={twMerge(
      "flex flex-col gap-4",
      "shrink-0 max-w-[calc(100vw-80px)] rounded-[16px] lg:flex-1 items-start gap-4 p-7",
    )}
  >
    <div className="flex items-center gap-4">
      <Image
        alt={`${testimonial.name} avatar`}
        src={testimonial.avatar}
        width={32}
        height={32}
        style={{
          borderRadius: "50%",
          objectFit: "cover",
          objectPosition: "top left",
        }}
      />
      <div className="flex flex-col gap-0">
        <div className="text-sm font-medium">{testimonial.name}</div>
        <div className="text-sm text-fg-secondary">{testimonial.company}</div>
      </div>
    </div>
    <div className="text-sm text-fg-secondary">&quot;{testimonial.quote}&quot;</div>
  </Card>
)

const Testimonials = () => {
  return (
    <Container>
      <div
        className="flex flex-col gap-6 items-center justify-center"
        style={{ padding: "100px 0" }}
      >
        <MarketingHeading
          className="text-[36px] md:text-[46px] leading-[0.9em]  mb-7 text-center"
          level={1}
        >
          Hear from our customers
        </MarketingHeading>
        {/* Desktop */}
        <div className={twMerge("flex items-center gap-8", "hidden lg:flex w-full gap-8")}>
          {groupedTestimonials.map((group, index) => (
            <div className="flex flex-col gap-8" key={index} style={{ flex: 1 }}>
              {group.map((testimonial, index) => (
                <TestimonialCard key={index} testimonial={testimonial} />
              ))}
            </div>
          ))}
        </div>
        {/* Mobile */}
        <div className="flex gap-8 lg:hidden w-[calc(100%+40px)] px-5 pb-5 overflow-x-auto items-start no-scrollbar">
          {groupedTestimonials.flat().map((testimonial, index) => (
            <TestimonialCard key={index} testimonial={testimonial} />
          ))}
        </div>
        <LinkButton size="large" variant="ghost" href="/customers">
          Explore more customer stories
          <Icon as={ArrowRight} />
        </LinkButton>
      </div>
    </Container>
  )
}

export default Testimonials
